<div class="view-container-parent">
	<div class="view-container-child" id="chatbot">
		<header>
			<div class="left-header-part">
				<div class="new-chat-button">
					@if (isChatbotFunctionalityAvailable()) {
						<stages-button
							[buttonType]="'button'"
							[title]="'chatbot.newTopic'"
							[iconClasses]="'ico-add'"
							[buttonClasses]="'button sm add'"
							[disabled]="showChips"
							(clicked)="newChat()"
						>
						</stages-button>
					}
				</div>
			</div>
			<div class="view-container">
				@if (selectionInput) {
					<stages-input
						class="first-child"
						(click)="isHistoryMode = false"
						[form]="form"
						[input]="selectionInput"
						[hideLabel]="true"
					/>
				}
				@if (isChatbotFunctionalityAvailable()) {
					<stages-button
						[buttonType]="'button'"
						[title]="'more'"
						[iconClasses]="'ico-more-vertical'"
						[buttonClasses]="'menu-button'"
						[showIconOnly]="true"
						(clicked)="openChildContainer(ChatbotChildContainer.MENU, ChatbotChildContainer.CHATBOT)"
					>
					</stages-button>
				}
				<div class="close-button">
					<stages-button
						[buttonType]="'button'"
						[title]="'close'"
						[iconClasses]="'ico-close'"
						[buttonClasses]="'menu-button'"
						[showIconOnly]="true"
						(clicked)="closeButtonPressed.emit()"
					>
					</stages-button>
				</div>
			</div>
		</header>
		@if (summary$ | async; as summary) {
			<div class="summary-header">
				<h3 class="summary">{{ summary }}</h3>
			</div>
		}
		@if (chatMessages$ | async; as chatMessages) {
			<div #chatbotPanel class="chatbot-panel" [ngClass]="{ 'with-summary': (summary$ | async) }">
				@if (_aiAcknowledgementsState === "NONE") {
					<stages-ai-acknowledgements
						(acknowledgementsState)="setAiAcknowledgementsState($event)"
						[processVersion]="currentProcessVersion!"
						[acceptButtonClasses]="'button sm save chip-expand'"
						[declineButtonClasses]="'button sm cancel chip-expand'"
					></stages-ai-acknowledgements>
				}
				@if (_aiAcknowledgementsState === "ACCEPTED") {
					@if (chatMessages.length == 0) {
						<stages-chatbot-welcome
							[customMessageHtml]="welcomeMessage$ | async"
							[showChips]="showChips"
						></stages-chatbot-welcome>
					}
					@if (showChips) {
						<div class="initial-view-selection">
							@for (view of selectableViews; track view) {
								<div class="view-chip-container">
									@if (view.id) {
										<stages-button
											[title]="view.name"
											[translateTitle]="false"
											[buttonClasses]="'button sm chip'"
											[buttonStyle]="{ 'background-color': view.color, color: view.textColor }"
											(click)="setInitialChatView(view.id!)"
										>
										</stages-button>
									}
								</div>
							}
						</div>
					}
				}
				@for (chatMessage of chatMessages; track chatMessage; let i = $index) {
					@if (chatMessage.type === "REQUEST") {
						<p
							class="box"
							ngClass="chat-request"
							[ngStyle]="{
								'background-color': coloredOptionForSelectedView?.color,
								color: coloredOptionForSelectedView?.textColor,
							}"
							[innerText]="chatMessage.formattedValue"
							(click)="reduceChatbotSize($event)"
						></p>
					}

					@if (chatMessage.type === "RESPONSE") {
						<div #responseMessage>
							<p
								class="box"
								ngClass="chat-response"
								[innerHTML]="chatMessage.formattedValue"
								(click)="reduceChatbotSize($event)"
							></p>

							@if (chatMessage.evidences.length > 0) {
								<div class="sources">
									<h3 translate="chatbot.sources"></h3>
									<ul class="evidence-list">
										@for (evidence of chatMessage.evidences; track evidence) {
											<li>
												<a
													(click)="reduceChatbotSize($event, true)"
													class="evidence-link"
													[title]="evidence.name"
													[attr.aria-label]="evidence.name"
													[routerLink]="getEvidenceLink(evidence)"
													><span class="evidence-name">{{ evidence.id }} {{ evidence.name }}</span
													><span class="evidence-type">[{{ evidence.typeName }}]</span></a
												>
											</li>
										}
									</ul>
								</div>
							}
						</div>
						@if (chatMessage.downloads.length > 0) {
							<div class="sources">
								<h3 translate="chatbot.downloads"></h3>
								<ul class="evidence-list">
									@for (download of chatMessage.downloads; track download) {
										<li>
											<a
												class="clickable evidence-link"
												[title]="download.name"
												[attr.aria-label]="download.name"
												(click)="downloadFile(download)"
												>{{ download.name }}</a
											>
										</li>
									}
								</ul>
							</div>
						}
						@if (chatGuid) {
							<stages-chatbot-message-toolbar
								[feedbackAllowed]="this.feedbackAllowed"
								[chatGuid]="chatGuid"
								[userRequest]="chatMessages[i - 1].messageText"
								[chatbotResponse]="chatMessage.messageText"
								[copyTarget]="responseMessage"
							></stages-chatbot-message-toolbar>
						}
					}
				}
				@if (isLoading$ | async; as isLoading) {
					@if (isLoading) {
						<p class="box chat-response"><span class="loading-dots"></span></p>
					}
				}
				@if (isStreaming$ | async; as isStreaming) {
					@if (isStreaming) {
						<p class="box chat-response" [innerHTML]="responseStream | async"></p>
					}
				}
				<p class="bottom-spacer"></p>
			</div>
		}
		<footer>
			@if (warningMessage) {
				<div class="warning-message">
					<div class="ico ico-warning"></div>
					{{ warningMessage | translate }}
				</div>
			}
			@if (errorMessage) {
				<div class="error-message">
					<div class="ico ico-warning"></div>
					{{ errorMessage | translate }}
				</div>
			}
			<stages-chatbot-input
				[disableSendButton]="isStreaming$ | async"
				[inputDisabled]="showChips || _aiAcknowledgementsState !== 'ACCEPTED'"
				(submitQuestion)="onSubmit($event)"
				(abortStreaming)="abort(true)"
				[focused]="inputFocused$ | async"
				[sendButtonConfiguration]="sendButtonConfiguration$ | async"
				[chatbotInputPlaceholder]="inputPlaceholder"
			></stages-chatbot-input>
		</footer>
	</div>
	<div class="view-container-child" id="menu">
		@if (settingsOpen) {
			<stages-chatbot-menu
				[currentChatGuid]="chatGuid"
				(closeButtonPressed)="openChildContainer(ChatbotChildContainer.CHATBOT, ChatbotChildContainer.MENU)"
				(triggerReload)="loadChat()"
				(triggerReset)="newChat()"
			>
			</stages-chatbot-menu>
		}
	</div>
</div>
